import React from "react";
import { SchoolWithExamRegistration } from "../../types/types";

interface SchoolInfoProps {
  registrationData: SchoolWithExamRegistration | null;
}

const SchoolInfo: React.FC<SchoolInfoProps> = ({ registrationData }) => {
  return (
    <div className="gceo-school-info">
      <div className="gceo-info-row">
        <span className="gceo-label">
          SCHOOL:
          {registrationData?.name ||
            "_____________________________________________________"}
        </span>
        <span className="gceo-label">
          DIVISION
          {registrationData?.division
            ? `:${registrationData.division}`
            : "______________________"}
        </span>
        <span className="gceo-label">
          REGION:
          {registrationData?.region
            ? `_${registrationData.region}_`
            : "____/____"}
        </span>
      </div>
      <div className="gceo-info-row">
        <span className="gceo-label">
          NAME / POSITION:
          {registrationData?.exam_registration?.payment_info?.payer_name ||
            "_________________________________________"}
          /
          {registrationData?.exam_registration?.payment_info?.payer_position ||
            "____________"}
        </span>
        <span className="gceo-label">
          TEL: {registrationData?.contact || "6_______________________"}
        </span>
      </div>
    </div>
  );
};

export default SchoolInfo;
